import React from "react"

import Helmet from "react-helmet"
import "./layout.css"

const Layout = ({ children }) => (
  <>
    <Helmet>
      <title>
        Código con Juan – Aprende Desarrollo web con cursos y creando proyectos
        del mundo real
      </title>
      <meta name="description" content="Sitio Código con Juan" />
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css?family=Caveat|Raleway:300,400,700,900&display=swap"
        rel="stylesheet"
      />
    </Helmet>

    {children}

    <footer className="site-footer py2">
      <div className="contenedor">
        <nav className="menu-principal">
          <ul id="menu-menu-principal-1" className="menu">
            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-15">
              <a href="https://codigoconjuan.com/">Cursos</a>
            </li>
            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-16">
              <a href="https://codigoconjuan.com/blog/">Blog</a>
            </li>
            <li className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-11 menu-item-18">
              <a href="https://codigoconjuan.com/podcast/" aria-current="page">
                Podcast
              </a>
            </li>
            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19">
              <a href="https://codigoconjuan.com/workshops/">Workshops</a>
            </li>
            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19">
              <a href="https://codigoconjuan.com/paths/">Paths</a>
            </li>
            <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-262">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://vidafreelancer.com"
              >
                Vida Freelancer
              </a>
            </li>
          </ul>
        </nav>
        <p className="copyright">Todos los derechos reservados © 2020.</p>
      </div>
    </footer>
  </>
)

export default Layout
